import { useMutation, useQueryClient } from "@tanstack/react-query";
import { programeazaTargetareDescoperire } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useProgrameazaTargetareDescoperire() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: programeazaTargetareDescoperire,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.contacteStats(),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
